// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import deriveDirectionLatitude from './deriveDirectionLatitude'
import deriveDirectionLongitude from './deriveDirectionLongitude'

/**
 * determines cardinal for coordinate value based on given axis
 * @param {XRegExp} r - instance of XRegExp
 * @param {String} axis - 'latitude' || 'longitude'
 * @param {Boolean} preferWesternHemisphere - allows us to force W hemisphere for positive longitude values w/o cardinal given
 * @returns {string|null} - returns either the derived cardinal value or null of formatting failed.
 */
const getCardinal = (r, axis, preferWesternHemisphere = false) => {
  // if there is both a prefix and a suffix, the format is wrong but
  // regex doesn't realize
  if (r.suffix && r.prefix.trim()) {
    return null
  }

  // if a suffix is given, just take that can call it a day.
  if (r.suffix) {
    return r.suffix.toUpperCase()
  }

  // otherwise, get the prefix value
  const p = r.prefix.trim().toUpperCase()

  return (
    axis === 'latitude' && deriveDirectionLatitude(p) ||
    axis === 'longitude' && deriveDirectionLongitude(p, preferWesternHemisphere) ||
    null
  )
}

export default getCardinal
